module.exports = __webpack_public_path__ + "img/0.119d59c4.jpg";